import InterviewPracticeGate from './gate';

const InterviewPracticePage = () => {
  return <InterviewPracticeGate />;
};

export default InterviewPracticePage;
